import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'student-rank-activities';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}`,
    data,
  });
}

export function restore(id, data) {
  return post({
    url: `${url}/${id}`,
    data,
  });
}

export function getRanks(id, data) {
  return get({
    url: `${url}/${id}/ranks`,
    data,
  });
}

export function refresh(id) {
  return post({
    url: `${url}/${id}/refresh`,
  });
}

export function getIssueVoucherPreview(id) {
  return get({
    url: `${url}/${id}/issue-vouchers/preview`,
  });
}

export function issueVouchers(id) {
  return post({
    url: `${url}/${id}/issue-vouchers`,
  });
}
